<template>
  <div class="listwrapper">
    <div class="loader-wrapper">
      <div
        v-if="isCustomTableLoading || isDbItemListLoading"
        class="progress-icon dark-color table-loader"
      ></div>
    </div>

    <CustomTable
      v-if="!(isCustomTableLoading || isDbItemListLoading)"
      ref="customTableRef"
      tableid="newtab"
      :dataHeader="headersList"
      :colWidth="getHeaderWidth"
      :dataList="filteredItems"
      @onDragOrResize="updateOnDragOrResize"
      :isCheckBoxEnabled="true"
      @onCheckBoxClick="onCheckBoxClick"
      :isCheckboxChecked="isCheckboxChecked"
      :getSqlKey="getSqlKey"
      :getHeaderContent="headerNameLableObject"
      :variableTableHeight="getTableHeight"
      :isCorrectElementType="isCorrectElementType"
      :generateLink="generateLink"
      :getFormattedElementToFixedValue="getFormattedElementToFixedValue"
      :getObjectData="getObjectData"
      :inlineView="inlineView"
      :database="database"
    >
      <template #default="loopitems">
        <div class="actioncontainer">
          <ul>
            <li
              @drop="dropWorkflowIcon($event)"
              @dragover.prevent.stop="handleDragOver"
              @dragleave.prevent.stop="handleDragLeave"
            >
              <ul :class="{ 'active-droppable': activeDropArea }">
                <li
                  class="show-btn"
                  :class="{ 'move-left': database.access_level == 'read' }"
                >
                  <!-- v-show="!dropdownOpen" -->

                  <a
                    v-if="database.type !== 'timetrigger'"
                    @click.prevent="onClickShowAction(loopitems)"
                    draggable="false"
                  >
                    Anzeigen
                  </a>
                </li>

                <!-- <li
              title="Teilen"
              @click="$emit('shareItem', loopitems.loopitems.item)"
            >
              <img src="../../assets/img/share-icon-new.svg" />
            </li>

            <li
              v-if="database.access_level != 'read'"
              title="Duplizieren"
              @click="$emit('duplicateItem', loopitems.loopitems.item)"
            >
              <img src="../../assets/img/copy-icon-new.svg" />
            </li>

            <li @click="$emit('exportItem', loopitems.loopitems.item, true)">
              <img src="../../assets/img/download-icon-new.svg" />
            </li>

            <li
              v-if="database.access_level !== 'read' && !database.add_only"
              title="Löschen"
              @click="$emit('deleteItem', loopitems.loopitems.item)"
            >
              <img src="../../assets/img/delete-icon-new.svg" />
            </li> -->

                <li
                  v-for="(item, index) in actionItems"
                  :key="index"
                  :title="item.name"
                >
                  <div
                    v-if="
                      !item.isActionItem &&
                      isDatabaseDropDownLoading(
                        item.id,
                        loopitems.loopitems.item.id
                      )
                    "
                    class="loadingoverlay"
                  >
                    <div
                      class="custom-table-progress-icon action-item-loader"
                    ></div>
                  </div>
                  <img
                    v-bind:src="getImgUrl(item.imageLink)"
                    v-if="item.isActionItem"
                    @click="actionEmitFunc(item, loopitems.loopitems.item)"
                    draggable="false"
                  />
                  <img
                    class="workflow-icon"
                    :src="
                      item.iconUrl
                        ? item.iconUrl
                        : getImgUrl('workflow-icon-new-light')
                    "
                    v-else-if="!item.isActionItem"
                    @click="actionEmitFunc(item, loopitems.loopitems.item)"
                    draggable="false"
                  />
                </li>
              </ul>
            </li>
            <li v-if="flowItems.length || userHasPermissionToAddFlow">
              <div
                :id="`custom-database-action-workflow-tooltip-${loopitems.loopitems.index}-${inlineView}`"
                class="action-workflow-tooltip"
                :class="{ 'inline-view': inlineView }"
              ></div>

              <generalDropdown
                :isCaretVisible="false"
                :uniqueReferenceId="
                  'customTableDropDownRef' + loopitems.loopitems.index
                "
                :ref="'customListDropdownRef' + loopitems.loopitems.index"
                @onDropdownClose="
                  loopitems.loopitems.onDropdownClose(
                    $event,
                    loopitems.loopitems.index
                  )
                "
                @onDropdownOpen="
                  loopitems.loopitems.onDropdownOpen(
                    $event,
                    loopitems.loopitems.index
                  )
                "
              >
                <template v-slot:iconContainer>
                  <li title="Mehr" class="dropdown-toggle">
                    <!-- @click="toggleActionDropdown()" -->
                    <img
                      class="dropdown-btn"
                      src="../../assets/img/more-icon.svg"
                    />
                  </li>
                </template>

                <template v-slot:optionData>
                  <!-- <b-dropdown-item
                    v-for="(a, index) in flowItems"
                    :key="a.id"
                    @click.native.capture.stop.prevent="
                      $emit('runAction', a.id, loopitems.loopitems.item.id)
                    "
                    class="dropdown-action-item"
                  > -->
                  <b-dropdown-item
                    draggable="false"
                    v-for="(a, index) in flowItems"
                    :key="a.id"
                    @click.native.capture.stop.prevent="
                      actionEmitFunc(a, loopitems.loopitems.item)
                    "
                    class="dropdown-action-item"
                    :class="{
                      'pointer-disabled': dropdownApiLoading,
                    }"
                  >
                    <div
                      v-if="
                        isDatabaseDropDownLoading(
                          a.id,
                          loopitems.loopitems.item.id
                        )
                      "
                      class="loadingoverlay"
                    >
                      <div class="custom-table-progress-icon"></div>
                    </div>
                    <div
                      class="workflow-name-wrapper"
                      @mouseenter="
                        showActionWorkflowTooltip(
                          $event,
                          a.isActionItem,
                          a.name,
                          loopitems.loopitems.index,
                          index
                        )
                      "
                      @mouseleave="
                        hideActionWorkflowTooltip(
                          loopitems.loopitems.index,
                          a.isActionItem
                        )
                      "
                    >
                      <img
                        v-if="!a.isActionItem"
                        @dragstart="dragStartWorkflowIcon($event, a, index)"
                        draggable="true"
                        class="workflow-icon"
                        :src="
                          a.iconUrl && a.adjustedIconUrl
                            ? a.adjustedIconUrl
                            : getImgUrl('workflow-icon-new-light')
                        "
                      />
                      <img
                        v-else-if="a.isActionItem"
                        @dragstart="dragStartWorkflowIcon($event, a, index)"
                        draggable="true"
                        class="workflow-icon"
                        v-bind:src="getImgUrl(a.imageLink)"
                      />
                      <span
                        draggable="false"
                        class="workflow-action"
                        :id="`workflow-action-${loopitems.loopitems.index}-${index}`"
                      >
                        {{ a.name }}
                      </span>
                    </div>
                    <div class="workflow-name-wrapper"></div>
                  </b-dropdown-item>
                  <b-dropdown-item
                    draggable="false"
                    v-if="userHasPermissionToAddFlow"
                    class="create-new-action"
                    @click="onCreateNewAction(loopitems.loopitems.item.id)"
                    :class="{
                      'pointer-disabled': dropdownApiLoading,
                      disabled: !userHasPermissionToAddFlow,
                    }"
                  >
                    <i class="far fa-plus-square"></i>Neue Aktion hinzufügen
                  </b-dropdown-item>
                </template>
              </generalDropdown>
            </li>
          </ul>
        </div>
      </template>
      <template #loadmore>
        <div class="load-more" v-if="isPaginationVisible() && !inlineView">
          <button @click="$emit('appendRows')" :disabled-="isRefreshing">
            <i class="fa fa-arrow-down me-2"></i>
            <span>Mehr anzeigen</span>
            <div
              v-if="loadMoreDataLoader"
              class="custom-table-progress-icon"
            ></div>
          </button>
        </div>
      </template>
    </CustomTable>
  </div>
</template>
<script>
import CustomTable from '../CustomTable.vue';
import Store from '../../store/store';
import GeneralDropdown from '../core/general-dropdown.vue';
import { debouncer, trimImage } from '../../utils/helpers';
import { mapGetters } from 'vuex';
import { getDataBaseTableSchema } from '../../services/userTable';
import { getCustomDatabaseItems } from '../../services/customdb.service';

export default {
  name: 'CustomDatabaseListView',
  data() {
    return {
      activeDropArea: false,
      actionItems: [
        {
          icon: 'share',
          name: 'Teilen',
          onClickText: 'shareItem',
          imageLink: 'share-icon-new',
          visible: true,
          isActionItem: true,
        },
        {
          icon: 'copy',
          name: 'Duplizieren',
          onClickText: 'duplicateItem',
          imageLink: 'copy-icon-new',
          visible: this.database.access_level != 'read',
          isActionItem: true,
        },
        {
          icon: 'download',
          name: 'Herunterladen',
          onClickText: 'exportItem',
          imageLink: 'download-icon-new',
          visible: true,
          isActionItem: true,
        },
        {
          icon: 'delete',
          name: 'Löschen',
          onClickText: 'deleteItem',
          imageLink: 'delete-icon-new',
          visible:
            this.database.access_level !== 'read' && !this.database.add_only,
          isActionItem: true,
        },
      ],
      flowItems: [],
      linkedDatabseItemList: {},
      isDbItemListLoading: false,
    };
  },
  props: {
    isCustomTableLoading: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Array,
    },
    items: {
      type: Array,
    },
    headersList: {
      type: Array,
      required: true,
    },
    database: {
      type: Object,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    filteredItems: {
      type: Array,
      required: true,
    },
    displayParam: {
      type: Function,
      required: true,
    },
    getSqlKey: {
      type: Function,
      required: true,
    },
    isSelectedItem: {
      type: Function,
      required: true,
    },
    headerNameLableObject: {
      type: Object,
      required: false,
    },

    isDatabaseDropDownLoading: {
      type: Function,
      reuqired: true,
    },
    inlineView: {
      type: Boolean,
      required: false,
      default: false,
    },
    dropdownApiLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    loadMoreDataLoader: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRefreshing: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemActionList: {
      tyep: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    async getImageProperties(url) {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = url;
      await img.decode();
      return img;
    },
    async getTrimImageData(imgUrl) {
      const img = await this.getImageProperties(imgUrl);
      const res = trimImage(img, img.width, img.height);
      return res;
    },
    handleDragOver() {
      this.activeDropArea = true;
    },
    handleDragLeave(e) {
      this.activeDropArea = false;
    },
    getImgUrl(img) {
      const images = require.context('../../assets/img/', false, /\.svg$/);
      return images(`./${img}.svg`);
    },
    actionEmitFunc(item, loopItems) {
      if (item.isActionItem) {
        if (
          item.icon === 'share' ||
          item.icon === 'copy' ||
          item.icon === 'delete'
        ) {
          this.$emit(item.onClickText, loopItems);
        } else if (item.icon === 'download') {
          this.$emit(item.onClickText, loopItems);
        }
      } else if (!item.isActionItem) {
        this.$emit('runAction', item.id, loopItems.id);
      }
    },
    dragStartWorkflowIcon(event, workflowData, index) {
      event.dataTransfer.setData('icon', JSON.stringify(workflowData));
      event.dataTransfer.setData('index', JSON.stringify(index));
    },
    async dropWorkflowIcon(event) {
      try {
        if (event.dataTransfer.getData('icon')) {
          const getWorkFlowData = JSON.parse(
            event.dataTransfer.getData('icon')
          );
          const removedItem = this.actionItems.pop();
          this.actionItems.unshift(getWorkFlowData);
          this.flowItems.splice(event.dataTransfer.getData('index'), 1);
          this.flowItems.unshift(removedItem);
          this.activeDropArea = false;
          const toolButtons = this.actionItems.map((action) => {
            return {
              isActionItem: action.isActionItem,
              workflowOrActionId: action.isActionItem ? action.icon : action.id,
            };
          });
          this.debounceFunction(() => {
            this.updatePutUserSettings(toolButtons);
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async updatePutUserSettings(toolButtons) {
      const settings = {
        customDatabaseSchema: {
          ...this.userSettings['customDatabaseSchema'],
          [this.database.name]: {
            ...this.userSettings['customDatabaseSchema'][this.database.name],
            toolButtons,
          },
        },
      };
      await this.$store.dispatch('putUserSettings', { settings });
    },
    debounceFunction(func, timeout = 1500, variableName) {
      debouncer(func, timeout, this, variableName);
    },

    async updateOnDragOrResize(data) {
      this.$emit('setCustomHighlightedItems', data.updatedHeaders);

      this.debounceFunction(() => {
        this.updateSettings(data.updatedHeadersWidth, data.updatedHeaders);
      });
    },
    async updateSettings(updatedHeadersWidth, updatedHeaders) {
      const updatedUserSettings = {
        settings: {
          customDatabaseSchema: {
            ...this.userSettings['customDatabaseSchema'],
            [this.database.name]: {
              ...this.userSettings['customDatabaseSchema']?.[
                this.database.name
              ],
              colWidth: updatedHeadersWidth,
              colPosition: [...new Set(updatedHeaders)],
            },
          },
        },
      };

      await this.$store.dispatch('putUserSettings', updatedUserSettings);
    },

    isCheckboxChecked(item) {
      return this.isSelectedItem(item[this.getSqlKey('id')]);
    },
    getObjectData(header, elementType) {
      if (this.database.schema) {
        const dataObject = JSON.parse(this.database.schema).find(
          (el) => el.name.trim() === header.trim()
        );
        if (dataObject && dataObject.type && dataObject.type === elementType) {
          return { isCorrectType: true, data: dataObject };
        }
      }
      return { isCorrectType: false, data: {} };
    },
    isCorrectElementType(header, elementType) {
      const { isCorrectType } = this.getObjectData(header, elementType);
      return isCorrectType;
    },
    generateLink(header, listData) {
      const { data, isCorrectType } = this.getObjectData(header, 'linktodb');
      if (isCorrectType) {
        const dataItem = listData ? listData : data.value;
        const linkDBShowCaseFieldValue = this.getLinkDBItemLabelValue(
          data,
          dataItem
        );
        const domain = window.location.origin;
        const url = `${domain}/#/?section=data&database=${data.selectedDatabaseID}&item=${dataItem}`;
        return `<a href="${url}" target="_blank" style="text-decoration: underline; color: #5f697a; position:relative; z-index:4;">${
          linkDBShowCaseFieldValue || data.name
        }</a>`;
      }
    },
    getLinkDBItemLabelValue(element, itemId) {
      if (
        this.linkedDatabseItemList &&
        element.selectedDatabaseID &&
        this.linkedDatabseItemList[element.selectedDatabaseID] &&
        this.linkedDatabseItemList[element.selectedDatabaseID]?.itemList?.length
      ) {
        const showCaseField =
          this.linkedDatabseItemList[element.selectedDatabaseID]?.showCaseField;
        const findData = this.linkedDatabseItemList[
          element.selectedDatabaseID
        ].itemList.find((item) => item.id === itemId);
        if (element.selectedDatabaseType === 'loadprofile') {
          return findData.name;
        }
        return findData && showCaseField ? findData[showCaseField] : itemId;
      }
      return itemId;
    },
    async setLinkedDatabaseItems() {
      try {
        this.isDbItemListLoading = true;

        const databaseLinkElements = JSON.parse(this.database.schema).filter(
          (el) => el.type === 'linktodb'
        );
        for (const element of databaseLinkElements) {
          if (this.linkedDatabseItemList[element.selectedDatabaseID]) continue;

          const findDatabase = this.getDatabaseList.find(
            (database) => database.name === element.selectedDatabaseID
          );
          let schema;
          if (findDatabase && findDatabase.schema) {
            schema = JSON.parse(findDatabase.schema);
          } else {
            const response = await getDataBaseTableSchema(
              element.selectedDatabaseID,
              true
            );
            if (response && response.status === 200 && response.data) {
              this.$store.commit('SET_DATABASE_SCHEMA', response.data);
              schema = JSON.parse(response.data.data);
            }
          }
          const findShowcaseField = schema.find(
            (el) => el?.settings?.showcaseField
          );

          const params = '?keys=' + (findShowcaseField?.name || '');

          const listItems = await getCustomDatabaseItems(
            element.selectedDatabaseID,
            params,
            true
          );
          if (listItems && listItems.status === 200 && listItems.data) {
            this.linkedDatabseItemList[element.selectedDatabaseID] = {
              itemList: listItems.data.items,
              showCaseField: findShowcaseField?.name,
            };
          }
        }
      } catch (error) {
        // eslint-disable-next-line
        console.log({ error });
      } finally {
        this.isDbItemListLoading = false;
      }
    },

    getFormattedElementToFixedValue(key) {
      const decimalCount = this.getObjectData(key, 'formatted_number')?.data
        ?.settings?.toFixed;
      return decimalCount !== undefined && decimalCount !== null
        ? decimalCount
        : 2;
    },
    isPaginationVisible() {
      return (
        this.pagination.isEnabled &&
        this.pagination.lastEvaluatedKey !== null &&
        !this.items.length < 1
      );
    },
    onCheckBoxClick(event, item) {
      this.$emit('checkSelectedItemOnClick', event, item);
    },
    showActionWorkflowTooltip(e, isActionItem, workflowName, itemIndex, index) {
      if (isActionItem) return;
      const workflowNameElem = document.getElementById(
        `workflow-action-${itemIndex}-${index}`
      );
      const isTextOverFlowed =
        workflowNameElem?.scrollWidth > workflowNameElem?.clientWidth;
      if (isTextOverFlowed) {
        const top = e.target?.getBoundingClientRect()?.top;
        const tooltip = document.getElementById(
          `custom-database-action-workflow-tooltip-${itemIndex}-${this.inlineView}`
        );
        if (tooltip && top) {
          tooltip.innerText = workflowName;
          tooltip.style.top = `${top}px`;
          tooltip.style.display = 'block';
        }
      }
    },
    hideActionWorkflowTooltip(itemIndex, isActionItem) {
      if (isActionItem) return;
      const tooltip = document.getElementById(
        `custom-database-action-workflow-tooltip-${itemIndex}-${this.inlineView}`
      );
      if (tooltip) {
        tooltip.innerText = '';
        tooltip.style.display = 'none';
      }
    },
    async validateDataBaseToolButtons() {
      if (
        this.userSettings.customDatabaseSchema?.[this.database.name] &&
        this.userSettings.customDatabaseSchema[this.database.name].toolButtons
      ) {
        const saveActionTools = this.userSettings.customDatabaseSchema[
          this.database.name
        ].toolButtons.filter(
          (tool) =>
            tool.isActionItem ||
            this.itemActionList.find(
              (action) => action.id === tool.workflowOrActionId
            )
        );
        if (4 > saveActionTools.length) {
          const includeStandardToolList = saveActionTools
            .filter((tool) => tool.isActionItem)
            .map((tool) => tool.workflowOrActionId);

          const unIncludedStandardToolList = this.actionItems
            .filter(
              (action) =>
                action.visible && !includeStandardToolList.includes(action.icon)
            )
            .map((action) => ({
              isActionItem: action.isActionItem,
              workflowOrActionId: action.icon,
            }));

          await this.updatePutUserSettings([
            ...saveActionTools,
            ...unIncludedStandardToolList.slice(0, 4 - saveActionTools.length),
          ]);
        }
      }
    },
    onClickShowAction(loopitems) {
      if (this.database.type === 'timetrigger') {
        this.$emit('onTimeTriggerEditItem', loopitems.loopitems.item);
      } else if (this.inlineView) {
        if (loopitems && this.$refs.customTableRef) {
          this.$refs.customTableRef.getPositionForActionBar(
            loopitems.loopitems.index
          );
          this.$store.dispatch('addSidebarLinkedCustomDBSettings', {
            ...loopitems.loopitems,
            database: this.database,
          });
        }
      } else {
        this.$router.push({
          path: '/',
          query: {
            section: 'data',
            database: this.database.name,
            item: loopitems.loopitems.item[this.getSqlKey('id')],
          },
        });
      }
    },
    onCreateNewAction(itemId) {
      if (this.userHasPermissionToAddFlow)
        this.$emit('createNewAction', itemId);
    },
  },
  async mounted() {
    await this.setLinkedDatabaseItems();
    //remove action icons from action Items if they don't have access
    this.actionItems = this.actionItems.filter((item) => item.visible);
    await this.validateDataBaseToolButtons();
    let actionList = [];
    for (let flow of this.itemActionList) {
      if (flow.iconUrl) {
        const baseUrl = await this.getTrimImageData(flow.iconUrl);
        flow.adjustedIconUrl = baseUrl;
      }
      actionList.push({
        ...flow,
        isActionItem: false,
      });
    }
    if (
      this.userSettings.customDatabaseSchema?.[this.database.name] &&
      this.userSettings.customDatabaseSchema[this.database.name].toolButtons
    ) {
      let allItems = [...this.actionItems, ...actionList];
      let flowItems = [];
      let actionItems = JSON.parse(
        JSON.stringify(
          this.userSettings.customDatabaseSchema[this.database.name].toolButtons
        )
      );
      for (const item of allItems) {
        const compareId = item.isActionItem ? item.icon : item.id;
        const findIndex = actionItems.findIndex((btn) => {
          return compareId === btn.workflowOrActionId;
        });
        if (findIndex !== -1) {
          actionItems[findIndex] = item;
        } else {
          flowItems.push(item);
        }
      }
      this.actionItems = actionItems;
      this.flowItems = flowItems;
    } else {
      this.flowItems = actionList;
    }
  },

  computed: {
    ...mapGetters({
      userHasPermissionToAddFlow: 'getUserPermissionToAddFlow',
      getDatabaseList: 'getDatabaseList',
    }),
    selectedItems() {
      return this.items.filter((i) =>
        this.isSelectedItem(i[this.getSqlKey('id')])
      );
    },
    getTableHeight() {
      let filterHeight = 0;
      if (this.filters?.length) {
        const filterElement = document.getElementById('filter-list-main-wrap');
        if (filterElement) {
          filterHeight = filterElement.offsetHeight - 20;
        }
      }

      const databseTitleElement = document.querySelector('.codelos-page-title');

      const databaseTitleElementHeight =
        this.database.caption &&
        databseTitleElement &&
        databseTitleElement?.offsetHeight > 50
          ? databseTitleElement.offsetHeight - 50
          : 0;
      const height =
        filterHeight + 54 + 18 + 120 + 20 + 100 + databaseTitleElementHeight;

      if (this.selectedItems && this.selectedItems.length) return height + 75;
      return height;
    },
    userSettings() {
      return this.$store.state.userSettings;
    },
    getHeaderWidth() {
      if (
        this.userSettings &&
        this.userSettings.customDatabaseSchema &&
        this.userSettings.customDatabaseSchema[this.database.name] !==
          undefined &&
        this.userSettings.customDatabaseSchema[this.database.name].colWidth !==
          undefined
      ) {
        return this.userSettings.customDatabaseSchema[this.database.name]
          .colWidth;
      } else {
        return {};
      }
    },
  },
  components: {
    CustomTable,
    GeneralDropdown,
  },
};
</script>
<style scoped>
.listwrapper .actioncontainer ul .dropdown-btn {
  cursor: pointer;
  transition: all 200ms ease-in-out;
  opacity: 0.6;
  width: 18px;
  margin-top: -2px;
}

.listwrapper .actioncontainer ul img {
  cursor: pointer;
  transition: all 200ms ease-in-out;
  margin-right: 25px;
  min-height: 14px;
}

.listwrapper .actioncontainer ul li img:hover {
  filter: brightness(0);
  opacity: 1;
}

.listwrapper .actioncontainer ul img:hover {
  filter: brightness(0);
}

.listwrapper .actioncontainer ul li.show-btn {
  transition: all 400ms ease-in-out;
  margin-right: 30px;
  /* transform: translateX(-50px); */
}

.listwrapper .actioncontainer ul li.show-btn a {
  display: block;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 6px 8px;
  min-width: 95px;
  text-align: center;
  color: #5f697a;
  text-transform: uppercase;
  font-size: 10px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease-in-out;
}

.listwrapper .actioncontainer ul li.show-btn a:hover {
  color: #2a2e35;
  border-color: #2a2e35;
}

.listwrapper .load-more {
  text-align: left;
  padding: 4px 0 10px;
  position: sticky;
  left: 0;
}
.listwrapper .actioncontainer ul .dropdown-action-item {
  position: relative;
}
.listwrapper .actioncontainer ul .pointer-disabled {
  pointer-events: none;
}
.listwrapper .actioncontainer ul .loadingoverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1f2532c7;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  text-align: center;
}

@keyframes progress-icon-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.listwrapper .actioncontainer ul .loadingoverlay .custom-table-progress-icon,
.load-more .custom-table-progress-icon {
  content: ' ';
  display: block;
  width: 30px;
  height: 30px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon-animation 1.2s linear infinite;
  margin: 0 auto;
  /* top: 5px; */
  position: absolute;
  left: 45%;
}
.listwrapper ::v-deep tr:hover td {
  border-top: 1px solid transparent !important;
}
.listwrapper ::v-deep tr:hover + tr td {
  border-top: 1px solid transparent !important;
}
.listwrapper ::v-deep tr:hover {
  position: relative;
}
.listwrapper {
  height: calc(100% - (78px + 130px + 20px));
  overflow: auto;
}
.progress-icon.dark-color {
  margin: auto;
}

.progress-icon.dark-color.center {
  left: auto;
}

.progress-icon.dark-color.table-loader {
  display: flex;
  justify-content: center;
  /* margin-top: 20px; */
  align-items: center;
  height: calc(-313px + 100vh);
  margin-top: 36px;
}

.progress-icon:after {
  content: ' ';
  display: block;
  width: 70px;
  height: 70px;
  margin: 1px;
  border-radius: 50%;
  border: 2px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: progress-icon 1.2s linear infinite;
}

.progress-icon.dark-color:after {
  border-color: #1f2532 transparent #1f2532 transparent;
  width: 100px;
  height: 100px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.dropdown-toggle::after {
  content: none;
}
.create-new-action {
  min-height: 25px;
  line-height: 1.5;
  font-size: 16px;
  margin-top: 5px;
  float: left;
  list-style: none;
  cursor: pointer;
  padding: 5px 11px;
  margin: 0;
  display: list-item;
  padding-top: 10px;
  border-top: 1px solid #eee;
  z-index: 1000;
}

.create-new-action:hover {
  background: #f0f0f0;
}
.create-new-action i {
  margin-right: 10px;
}
.listwrapper .create-new-action ::v-deep a {
  color: black !important;
}
.listwrapper ::v-deep .dropdown-menu:has(.create-new-action.disabled) {
  border: 1px solid #d4d4d4;
}

.listwrapper .actioncontainer ul .create-new-action.disabled {
  border: none;
}
.listwrapper .actioncontainer ul .create-new-action.disabled ::v-deep a {
  color: #d4d4d4 !important;
  background-color: #efefef !important;
  cursor: not-allowed;
}

.load-more button {
  background: transparent;
  border: none;
  color: #555555;
  padding: 7px 10px;
  font-size: 14px;
  -webkit-transition: all 300ms ease-in-out;
  transition: all 300ms ease-in-out;
  border-radius: 5px;
  display: flex;
  align-items: center;
}
.load-more button:hover {
  color: #555555;
  background: #dfdfdf80;
  color: black;
}
.load-more .custom-table-progress-icon {
  width: 20px;
  height: 20px;
  border: 1px solid #555555;
  border-color: #555555 transparent #555555 transparent;
  position: unset;
  margin-left: 10px;
}
ul li {
  line-height: 17px;
}

li {
  display: item;
  text-align: -webkit-match-parent;
}
.listwrapper .workflow-name-wrapper {
  display: flex;
  align-items: center;
}
.listwrapper .workflow-icon {
  vertical-align: top;
  border-style: none;
  width: 25px;
  margin-right: 12px;
  padding-left: 2px;
  height: 25px;
}
.listwrapper .active-droppable {
  background-color: #8b8b8b;
}
.listwrapper .active-droppable a {
  border: none !important;
}
.listwrapper .active-droppable:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10000;
}
.listwrapper .action-item-loader {
  width: 24px !important;
  height: 24px !important;
}
.listwrapper ::v-deep .dropdown-toggle.btn:focus-visible {
  box-shadow: none;
  -webkit-box-shadow: none !important;
}
.listwrapper .workflow-name-wrapper .workflow-action {
  text-overflow: ellipsis;
  overflow-x: hidden;
  width: 117px;
  max-width: 100%;
  white-space: nowrap;
  color: black;
}

.listwrapper ::v-deep .dropdown-menu::-webkit-scrollbar {
  width: 4px;
}

.listwrapper ::v-deep .dropdown-menu::-webkit-scrollbar-track {
  border-radius: 7px;
  background-color: transparent;
  border: 1px solid transparent;
}

.listwrapper ::v-deep .dropdown-menu::-webkit-scrollbar-thumb {
  border-radius: 7px;
  background-color: #565656;
}

.listwrapper ::v-deep .dropdown-menu .dropdown-action-item .dropdown-item {
  padding: 0px !important;
}

.listwrapper
  ::v-deep
  .dropdown-menu
  .workflow-name-wrapper:has(.workflow-action) {
  padding: 10px;
}
.listwrapper .action-workflow-tooltip {
  position: Fixed;
  right: 268px;
  display: none;
  max-width: 220px;
  background-color: #414141;
  color: #fdfdfd;
  padding: 10px;
  border-radius: 10px;
  word-break: break-all;
}

.listwrapper .action-workflow-tooltip {
  position: Fixed;
  right: 268px;
  display: none;
  max-width: 220px;
  background-color: #414141;
  color: #fdfdfd;
  padding: 10px;
  border-radius: 10px;
  word-break: break-all;
}
.listwrapper .action-workflow-tooltip.inline-view {
  right: 528px !important;
}

.listwrapper .loader-wrapper {
  position: absolute;
  top: 0;
  width: 100%;
  background-color: white;
}
</style>
